const CLIENT_INSTANCE_STORAGE_KEY = 'akive-client-instance-id'

function createClientInstanceId() {
  return window.crypto?.randomUUID?.()
    || `akive-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

function getClientInstanceId() {
  if (typeof window === 'undefined') return null

  try {
    return window.localStorage.getItem(CLIENT_INSTANCE_STORAGE_KEY)
  } catch {
    return null
  }
}

function getOrCreateClientInstanceId() {
  const existingId = getClientInstanceId()
  if (existingId) return existingId

  const clientInstanceId = createClientInstanceId()
  try {
    window.localStorage.setItem(CLIENT_INSTANCE_STORAGE_KEY, clientInstanceId)
  } catch {
    // 저장소 접근이 제한되면 현재 탭에서만 식별자를 사용한다.
  }
  return clientInstanceId
}

function clearClientInstanceId() {
  if (typeof window === 'undefined') return

  try {
    window.localStorage.removeItem(CLIENT_INSTANCE_STORAGE_KEY)
  } catch {
    // 저장소 접근이 제한돼도 메모리 인증 세션 정리는 계속한다.
  }
}

export {
  clearClientInstanceId,
  getClientInstanceId,
  getOrCreateClientInstanceId,
}
